import { Multiselect } from "@wizardhealth/stimulus-multiselect";
import CustomMultiselectListManage from "../packs/custom_multiselect_list_manage";

let existsValueList = [];

export default class extends Multiselect {
  static targets = ["multiselect"];

  static values = {};

  connect() {
    super.connect();
    for (let index = 0; index < this.multiselectTargets.length; index++) {
      const element = this.multiselectTargets[index];
      this.initialAllSelectOption(element);

      element.addEventListener("multiselect-added", (event) => {
        this.addFromExistsValue(element, event.detail);
        this.dispatch("triggerMultiselectAddEvent", { detail: event.detail });
      });

      element.addEventListener("multiselect-change", (event) => {
        this.dispatch("triggerMultiselectChangeEvent", {
          detail: event.detail,
        });
      });

      element.addEventListener("multiselect-removed", (event) => {
        this.removedFromExistsValue(element, event.detail);
        this.toogleStyleDisplay();
        this.dispatch("triggerMultiselectRemoveEvent", {
          detail: event.detail,
        });
      });
    }

    document.addEventListener("custom-multiselect-removed", (event) => {
      this.removeCustomItem(event);
    });

    if (this.hasSelectedValue && this.selectedValue.length) {
      this.searchTargets.forEach((search) => {
        search.style.display = "none";
      });
    }
  }

  disconnect() {
    super.disconnect();
    for (let index = 0; index < this.multiselectTargets.length; index++) {
      const element = this.multiselectTargets[index];
      element.removeEventListener("multiselect-added", (event) => {
        this.dispatch("triggerMultiselectAddEvent", { detail: event.detail });
      });
      element.removeEventListener("multiselect-removed", (event) => {
        this.toogleStyleDisplay();
        this.dispatch("triggerMultiselectRemoveEvent", {
          detail: event.detail,
        });
      });
      element.removeEventListener("custom-multiselect-removed", (event) => {});
    }
    existsValueList = [];
  }

  // TODO
  // We need to add a specific configuration for this feature. Because sometimes we don't want to use it

  // we need to check there is already a record using override toogleItem(input) method
  // if we have an already a record we can skip, otherwise we can add
  toggleItem(input) {
    let isAddToItem = CustomMultiselectListManage("toggleItem", "", "", input);
    if (isAddToItem) {
      super.toggleItem(input);
    } else {
      this.dispatch("triggerMultiselectHasAlreadyRecord", { detail: input });
    }
  }

  addFromExistsValue(element, selectedValue) {
    CustomMultiselectListManage("add", element, selectedValue, "");
  }

  removedFromExistsValue(element, selectedValue) {
    CustomMultiselectListManage("remove", element, selectedValue, "");
  }

  initialAllSelectOption(element) {
    CustomMultiselectListManage("initial", element, this.selectedValue, "");
  }

  removeCustomItem(e) {
    this.listTargets;
    this.selectedItems;
  }

  toogleStyleDisplay(e) {
    this.searchTargets.forEach((item) => {
      if ((item.style.display = "none")) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  }
}
